import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PaymentMethodModal = ({ isOpen, onClose }) => {
  const [cardNumber, setCardNumber] = useState('');
  const [cardName, setCardName] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [cvv, setCvv] = useState('');
  const [billingAddress, setBillingAddress] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e?.preventDefault();
    console.log('Updating payment method');
    onClose();
  };

  const formatCardNumber = (value) => {
    const cleaned = value?.replace(/\s/g, '');
    const formatted = cleaned?.match(/.{1,4}/g)?.join(' ') || cleaned;
    return formatted?.slice(0, 19);
  };

  const formatExpiryDate = (value) => {
    const cleaned = value?.replace(/\D/g, '');
    if (cleaned?.length >= 2) {
      return cleaned?.slice(0, 2) + '/' + cleaned?.slice(2, 4);
    }
    return cleaned;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-lg w-full max-w-md max-h-[90vh] overflow-y-auto elevation-xl animate-in fade-in zoom-in duration-200">
        <div className="flex items-center justify-between p-4 lg:p-6 border-b border-border sticky top-0 bg-card z-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
              <Icon name="CreditCard" size={20} color="var(--color-primary)" />
            </div>
            <h3 className="text-lg font-semibold text-foreground font-heading">
              Update Payment Method
            </h3>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-md hover:bg-muted transition-smooth flex items-center justify-center"
          >
            <Icon name="X" size={18} color="var(--color-muted-foreground)" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-4 lg:p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-foreground font-body mb-2">
              Card Number
            </label>
            <input
              type="text"
              value={cardNumber}
              onChange={(e) => setCardNumber(formatCardNumber(e?.target?.value))}
              placeholder="1234 5678 9012 3456"
              className="w-full px-3 lg:px-4 py-2 bg-background border border-border rounded-md text-sm text-foreground font-body placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground font-body mb-2">
              Cardholder Name
            </label>
            <input
              type="text"
              value={cardName}
              onChange={(e) => setCardName(e?.target?.value)}
              placeholder="John Doe"
              className="w-full px-3 lg:px-4 py-2 bg-background border border-border rounded-md text-sm text-foreground font-body placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
              required
            />
          </div>

          <div className="grid grid-cols-2 gap-3 lg:gap-4">
            <div>
              <label className="block text-sm font-medium text-foreground font-body mb-2">
                Expiry Date
              </label>
              <input
                type="text"
                value={expiryDate}
                onChange={(e) => setExpiryDate(formatExpiryDate(e?.target?.value))}
                placeholder="MM/YY"
                className="w-full px-3 lg:px-4 py-2 bg-background border border-border rounded-md text-sm text-foreground font-body placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
                maxLength={5}
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground font-body mb-2">
                CVV
              </label>
              <input
                type="text"
                value={cvv}
                onChange={(e) => setCvv(e?.target?.value?.replace(/\D/g, '')?.slice(0, 3))}
                placeholder="123"
                className="w-full px-3 lg:px-4 py-2 bg-background border border-border rounded-md text-sm text-foreground font-body placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
                maxLength={3}
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground font-body mb-2">
              Billing Address
            </label>
            <textarea
              value={billingAddress}
              onChange={(e) => setBillingAddress(e?.target?.value)}
              placeholder="Enter your billing address"
              rows={3}
              className="w-full px-3 lg:px-4 py-2 bg-background border border-border rounded-md text-sm text-foreground font-body placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50 resize-none"
              required
            />
          </div>

          <div className="flex items-start gap-2 p-3 bg-primary/10 border border-primary/20 rounded-lg">
            <Icon name="Lock" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
            <p className="text-xs text-muted-foreground font-caption">
              Your payment information is encrypted and secure. We use industry-standard security measures to protect your data.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              size="default"
              fullWidth
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="primary"
              size="default"
              fullWidth
              iconName="CheckCircle"
              iconPosition="left"
            >
              Update Card
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PaymentMethodModal;